import React from 'react';
import './Sidebar.scss';

export const SidebarHeader = ({ children }) => {
    return <header className="kite-container nav-header">{children}</header>;
};

export const SidebarBody = ({ children }) => {
    return <section>{children}</section>;
};

export const Sidebar = ({
    children,
    className,
    expanded,
    ariaHidden,
}: {
    children: any;
    className?: string;
    expanded: boolean;
    ariaHidden?: boolean;
}) => {
    return (
        <aside
            className={`sidebar ${className ? className : ``} ${
                expanded ? `expanded` : ``
            }`}
            aria-hidden={ariaHidden}
        >
            {children}
        </aside>
    );
};
